import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  enterKanaName: () => i18n.t(i18nKeys.profileSetup__enterKanaName),
  enterLegalName: () => i18n.t(i18nKeys.profileSetup__enterLegalName),
  required: () => i18n.t(i18nKeys.common__required),
  firstName: () => i18n.t(i18nKeys.common__firstName),
  legalFirstName: () => i18n.t(i18nKeys.common__legalFirstName),
  middleName: () => i18n.t(i18nKeys.common__middleName),
  legalMiddleName: () => i18n.t(i18nKeys.common__legalMiddleName),
  noMiddleNameLabel: () => i18n.t(i18nKeys.profileSetup__noMiddleNameLabel),
  lastName: () => i18n.t(i18nKeys.common__lastName),
  legalLastName: () => i18n.t(i18nKeys.common__legalLastName),
}
